import { LIMB_REACH } from "../content/abilities/reach";
import { FIGHTER, reactionLean, type AbilityDef, type FighterState, type ReactionKind } from "../sim";

/**
 * Довод до касания (консультант 05.11.2026: «кость в кадр засчитанного попадания ≤ 20 px от тела соперника»): зона
 * удара засчитывает чуть раньше, чем кость клипа дойдёт до тела, — в окне удара модель бьющего подаётся вперёд на
 * нехватку: расстояние до соперника минус досягаемость кости (content/abilities/reach.ts) минус TOUCH. Только картинка:
 * мир и зоны удара те же. Окно — за LEAD кадров до первого активного и до конца активных.
 */
const TOUCH = 4;
/** Ногами и коленом — чуть внутрь тела: нога соперника тоньше корпуса, касание считается по кости в её середине. */
const TOUCH_LEG = -4;
const MAX_LEAN = 34;
const LEAD = 5;

export function reachLean(
  fighter: FighterState,
  other: FighterState,
  ability: AbilityDef | undefined,
  otherBody?: Readonly<Record<ReactionKind, readonly number[]>>,
): number {
  if (fighter.state !== FIGHTER.ability || !ability?.hit || ability.projectile) return 0;
  if (fighter.abilityFrame < ability.startup - LEAD || fighter.abilityFrame > ability.startup + ability.active + 1)
    return 0;
  const reach = LIMB_REACH[ability.id];
  if (!reach) return 0;
  // соперник в реакции: тело откинуто (голова назад, корпус вперёд) — довод до тела, а не до места мира (sim/reaction.ts)
  const gap = Math.abs(other.x - fighter.x) / 256 - reactionLean(other, otherBody);
  const touch = reach.limb.endsWith("ToeBase") || reach.limb.endsWith("Leg") ? TOUCH_LEG : TOUCH;
  return Math.min(MAX_LEAN, Math.max(0, gap - reach.forward - touch));
}
